export default __webpack_public_path__ + "static/media/tides.293a0497.svg";